import { render, staticRenderFns } from "./Confetti.vue?vue&type=template&id=b0f88f70"
import script from "./Confetti.vue?vue&type=script&lang=js"
export * from "./Confetti.vue?vue&type=script&lang=js"
import style0 from "./Confetti.vue?vue&type=style&index=0&id=b0f88f70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports